export enum SiderBreakpoint {
  VerySmall = "xs",
  Small = "sm",
  Medium = "md",
  Large = "lg",
  VeryLarge = "xl",
  Largest = "xxl",
}
